import { Grid, Typography } from '@mui/material';

const SummaryLine = ({ label = '', value = '' }) => (
  <Grid container>
    <Grid item xs={12} md={6}>
      <Typography color="text.secondary">{label}:</Typography>
    </Grid>
    <Grid item xs={12} md={6}>
      <Typography>{value}</Typography>
    </Grid>
  </Grid>
);

export default SummaryLine;
